<template>
  <section class="login-reg notop">
    <div class="container">
      <div class="log-box fullw">
  <div class="">
    <div class="top-video-container" :class="{compact: !item.media}">
      <edit-video v-on:delete="deleteVideo" v-on:set="setVideo" :media="item.media" :thumbnail="item.thumbnail" :chapters="item.chapters" />
    </div>
    <div class="post-container">
      <div class="post-head">
        <div class="head-props">
          <div class="type" :class="{open: typeOpened}" v-on:click.prevent="typeOpened=!typeOpened" style="max-width: 80% !important; width: 500px !important">
            <span v-if="item.type">{{ item.type.title }}</span>
            <span v-else>(no type selected)</span>
            <ul style="z-index: 20">
              <li v-for="type in types" :class="{active: item.type && type.id==item.type.id}" v-on:click="select('type', type); typeOpened=false">{{ type.title }}</li>
            </ul>
          </div>
          <div class="group" :class="{open: groupOpened}" v-on:click.prevent="groupOpened=!groupOpened" style="max-width: 230px">
            <span v-if="item.parent">{{ item.parent.subtitle }}</span>
            <span v-else-if="!item.subtitle">(standalone video)</span>
            <span v-else>(first video of a group)</span>
            <ul style="z-index: 20; width: 600px; max-height: 250px; overflow: auto;">
              <li style="width: auto" :class="{active: item.parent==null}" v-on:click="select('parent', null); groupOpened=false">(standalone or first video)</li>
              <li style="width: auto" v-for="parent in parents" :class="{active: item.parent && parent.id==item.parent.id}" v-on:click="select('parent', parent); groupOpened=false">{{ parent.subtitle }}</li>
            </ul>
          </div>
          <div class="group2" v-if="!item.parent">
            <label>Group title</label>
            <input v-model="item.subtitle" class="text-field" />
          </div>
          <div class="thumb" :class="{open: thumbnailEditor}" v-if="item.media && !testEditor && !chapterEditor">
            <div class="thumb-box" v-on:click="thumbnailEditor=!thumbnailEditor">
              <i></i>
            </div>
            <thumbnail-editor v-if="thumbnailEditor" :item="item" v-on:done="thumbnailEditor=false" />
          </div>
          <div class="testqs" :class="{open: testEditor}" v-if="item.media && !thumbnailEditor && !chapterEditor">
            <div class="testqs-box" v-on:click="testEditor=!testEditor">
              <i></i>
            </div>
            <test-editor v-if="testEditor" :item="item" v-on:done="testEditor=false" />
          </div>
          <div class="chapters" :class="{open: chapterEditor}" v-if="item.media && !thumbnailEditor && !testEditor">
            <div class="chapters-box" v-on:click="chapterEditor=!chapterEditor">
              <i></i>
            </div>
            <chapter-editor v-if="chapterEditor" :item="item" v-on:done="chapterEditor=false" />
          </div>
        </div>
        <dyn-textarea class="title-input" v-model="item.title" v-on:keydown="titleKeyDown" placeholder="Enter title here"></dyn-textarea>
        <ul class="details-list">
          <li style="width: 100%">
            <label>Date:</label>
            <input ref="createdDate" v-model="item.created" class="datepicker-field" />
          </li>
          <li v-if="!item.parent">
            <label>1 day (USD):</label>
            <input type="text" v-model="item.priceUsd" class="price-box" />
          </li>
          <li v-if="!item.parent">
            <label>3 days:</label>
            <input type="text" v-model="item.price1" class="price-box" />
          </li>
          <li v-if="!item.parent">
            <label>7 days:</label>
            <input type="text" v-model="item.price2" class="price-box" />
          </li>
          <li v-if="!item.parent">
            <label>30 days:</label>
            <input type="text" v-model="item.price3" class="price-box" />
          </li>
          <li v-if="!item.parent">
            <label>90 days:</label>
            <input type="text" v-model="item.price4" class="price-box" />
          </li>
        </ul>
        <ul class="details-list details-discount">
          <li style="width: 40%">
            <label>Discount expiry:</label>
            <input ref="discountexpiry" v-model="item.discountexpiry" class="datepicker-field" />
          </li>
          <li style="width: 30%">
            <label>Code:</label>
            <input type="text" v-model="item.discountkey" />
          </li>
          <li style="width: 20%">
            <label>Percent:</label>
            <input type="text" v-model="item.discountpercent" class="price-box" />
          </li>
        </ul>
      </div>
      </div>
      <div class="post-content">
        <div class="auth auth-edit">
          <template v-if="item.author">
          <div class="auth-img"><i></i>
            <router-link :to="{name: 'content.teacher', params: {id: item.author.username}}">
              <img :src="photoLinkR(item.author.media, 256, 256, 'Fit')" />
            </router-link>
          </div>
          <div>
            <div class="name">{{ item.author.pubname || (item.author.firstname+" "+item.author.lastname) }}</div>
          </div>
          </template>
          <div v-else>(no author)</div>
          <ul v-if="isAdmin">
            <li v-for="type in authors" :class="{active: item.author && type.id==item.author.id}" v-on:click="select('author', type)" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ type.pubname || (type.firstname+" "+type.lastname) }}</li>
          </ul>
        </div>
        <draggable v-model="item.blocks" handle=".drag">
        <template v-for="(block, bi) in item.blocks">
          <edit-intro :key="'item'+(block.id || block.tempId)" v-if="block.type=='intro'" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:remove="removeBlock(bi)" :block="block" />
          <edit-text :key="'item'+(block.id || block.tempId)" v-else-if="block.type=='text'" v-model="block.content" v-on:new-block="newBlock(bi, $event)" :block="block" v-on:remove="removeBlock(bi)" />
          <edit-image :key="'item'+(block.id || block.tempId)" v-else-if="block.type=='image'" v-model="block.content" v-on:remove="removeBlock(bi)" :block="block" />
          <edit-h2 :key="'item'+(block.id || block.tempId)" v-else-if="block.type=='h2'" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:remove="removeBlock(bi)" :block="block" />
          <edit-blockquote :key="'item'+(block.id || block.tempId)" v-else-if="block.type=='blockquote'" v-model="block.content" v-on:new-block="newBlock(bi, $event)" v-on:remove="removeBlock(bi)" :block="block" />
        </template>
        </draggable>
    <div class="pe-toolbar">
      <div class="pet-inner">
        <ul>
          <li class="intro">
            <a href="" v-on:click.prevent="newBlockType('intro')"><span>add</span><i></i><em>Intro</em></a>
          </li>
          <li class="text">
            <a href="" v-on:click.prevent="newBlockType('text')"><span>add</span><i></i><em>Text</em></a>
          </li>
          <li class="image">
            <a href="" v-on:click.prevent="newBlockType('image')"><span>add</span><i></i><em>Image/File</em></a>
          </li>
          <li class="quote">
            <a href="" v-on:click.prevent="newBlockType('blockquote')"><span>add</span><i></i><em>Quote</em></a>
          </li>
          <li class="h2">
            <a href="" v-on:click.prevent="newBlockType('h2')"><span>add</span><i></i><em>Heading</em></a>
          </li>
        </ul>
      </div>
    </div>
        <edit-tags :item="item" />
      </div>
      <div class="post-comments" v-if="false">
        <div class="comments-toggle">
          <label class="check">
            <input type="checkbox" v-model="item.hasComments"></input>
            <i></i>
            <span>Comments are {{ item.hasComments?"On":"Off" }}</a></span>
          </label>
        </div>
        <h4>{{ formatPlural(item.comments.length, "comment") }}</h4>
        <edit-comments v-model="item.comments" :item="item" />
        
      </div>
      <div class="form-act">
        <button class="lbtn" v-on:click.prevent="saveItem">Save</button>
      </div>
    </div>
  </div>
      </div>
    </div>
  </section>
</template>
<script>
import moment from 'moment';
import api from './api';
var tempNum=0;

export default {
  data: ()=>({
    menuItems: [],
    item: {
      language: "English",
      blocks: [],
      comments: [],
    },
    typeOpened: false,
    groupOpened: false,
    groups: [],
    types: [],
    parents: [],
    authors: [],
    langSelector: false,
    thumbnailEditor: false,
    testEditor: false,
    chapterEditor: false,
    posttype: "video",
    languages: {
      English: "English",
      French: "Français",
    },
    isAdmin: false,
    playTime: 0,
    duration: 0,
  }),
  created() {
    this.loadItem();
    this.loadTypes();
    this.loadGroups();
    this.loadAuthors();
    this.isAdmin=window.appData.currentUser && window.appData.currentUser.admin==1;
    if (!this.isAdmin)
      location.replace("/");
  },
  mounted() {
    var that=this;
    $(this.$refs.createdDate).datetimepicker({
      format: "Y-m-d H:i",
      step: 5,
      onSelectDate() {
        that.item.created=that.$refs.createdDate.value;
      },
      onSelectTime() {
        that.item.created=that.$refs.createdDate.value;
      },
    });
    $(this.$refs.discountexpiry).datetimepicker({
      format: "Y-m-d H:i",
      step: 5,
      onSelectDate() {
        that.item.discountexpiry=that.$refs.discountexpiry.value;
      },
      onSelectTime() {
        that.item.discountexpiry=that.$refs.discountexpiry.value;
      },
    });
  },
  watch: {
    "item.title": function() {
      this.item.title=this.item.title.replace(/\n/g, " ");
    },
  },
  computed: {
  },
  methods: {
    async loadTypes() {
      this.types=(await api.list("VideoType", {}, ["title:ASC"])).items;
      this.types=this.types.map((a)=>{
        var prefix="";
        if (a.parent && this.types.find((b)=>b.id==a.parent))
          prefix=this.types.find((b)=>b.id==a.parent).title+" / ";
        return {...a, title: prefix+a.title};
      }).sort((a,b)=>{
        if (a.id*1<b.id*1) return -1;
        if (a.id*1>b.id*1) return 1;
        return 0;
      });
    },
    async loadGroups() {
      this.groups=(await api.list("VideoGroup", {}, ["title:ASC"])).items;
      var id=this.$route.params.id;
      this.parents=(await api.list("Video", {parent: "null", id: ["<>", id]}, ["title:ASC"])).items.filter((a)=>a.subtitle);
    },
    async loadAuthors() {
      this.authors=(await api.list("User", {teacher: 1}, ["firstname:ASC"])).items;
    },
    async loadItem() {
      var id=this.$route.params.id;
      if (id*1) {
        this.item=(await api.get("Video", id)).item || {};
        if (!this.item.blocks)
          this.item.blocks=[];
        this.item.blocks.sort((a,b)=>{
          if (a.order_index*1<b.order_index) return -1;
          if (a.order_index*1>b.order_index) return 1;
          return 0;
        });
        this.item.created=moment(this.item.created).format("YYYY-MM-DD HH:mm");
      } else {
        this.item.created=moment().format("YYYY-MM-DD HH:mm");
        this.item.author=(await api.get("User", window.appRoot.loggedIn.id)).item;
        this.item.posttype=id.substring(4);
        this.item.duration="1";
      }
      this.item.chapters=this.item.chapters || [
        {time: 0, title: ""}
      ];
    },
    async saveItem() {
      var item=JSON.parse(JSON.stringify(this.item));
      delete item.comments;
      var fields=["type", "media", "thumbnail", "author", "group"];
      for(var field of fields) {
        var newField="new"+field[0].toUpperCase()+field.substring(1);
        delete item[field];
        delete item[newField];
        if (this.item[newField]!==undefined)
          item[field]=this.item[newField];
      }
      for(var i in item.blocks) {
        var block=item.blocks[i];
        block.order_index=i;
      }
//       item.created=item.created || "CURRENT_TIMESTAMP";
      if (item.id) {
//         delete item.author;
        await api.update("Video", this.item.id, item);
      } else {
//         item.author=item.author.id;
        await api.create("Video", item);
      }
      if (this.item.media)
        api.update("Media", this.item.media.id, {thumbnail: this.item.media.thumbnail});
      this.$router.push({name: "admin.posts"});
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    photoLinkR(media, width, height, mode) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return '/api/Media/'+media.id+'/resize?w='+width+"&h="+height+"&m="+mode;
    },
    goComments() {
      var $comments=$(this.$refs.comments);
      var $top=$(".content.active");
      $top.animate({scrollTop: $top.scrollTop()+$comments.offset().top}, 300);
    },
    deleteVideo() {
      this.item.media=null;
      this.$set(this.item, "newMedia", null);
    },
    setVideo(video) {
      this.$set(this.item, "media", video);
      this.$set(this.item, "newMedia", video.id);
    },
    select(field, value) {
      var newField="new"+field[0].toUpperCase()+field.substring(1);
      this.$set(this.item, field, value);
      this.$set(this.item, newField, value && value.id);
      this.item=JSON.parse(JSON.stringify(this.item));
    },
    titleKeyDown($event) {
      if ($event.key=="Enter")
        $event.preventDefault();
    },
    newBlock(index, $value) {
      this.item.blocks.splice(index+1, 0, {
        parent: null,
        order_index: null,
        column_index: null,
        type: "text",
        content: $value.content,
        "new": true,
        tempId: "new"+tempNum++,
      });
    },
    newBlockType(type) {
      this.item.blocks.push({
        parent: null,
        order_index: null,
        column_index: null,
        type: type,
        content: "",
        "new": true,
        tempId: "new"+tempNum++,
      });
    },
    removeBlock(index) {
      this.item.blocks.splice(index, 1);
    },
    toggleLanguage() {
      this.langSelector=true;
    },
    selectLanguage(language) {
      this.$set(this.item, "language", language);
      this.langSelector=false;
    },
    formatPlural(count, prefix) {
      if (count==0)
        return "No "+prefix+"s";
      if (count==1)
        return count+" "+prefix;
      return count+" "+prefix+"s";
    },
  },
}
</script>
